import config from './WebIMConfig'
import websdk from 'easemob-websdk'
import _ from 'lodash'
import { message as Message } from 'ant-design-vue'
import store from '@/store'
import EventBus from '@/utils/EventBus.js'
import { createCmdMessageHandler } from '@/utils/cmdMessageHandler'
import Config from '@/config/index'
import useCustomIM from '@/hooks/useCustomIM'
import { computed } from 'vue'
import { handleGroupMembers } from '@/utils/index'

// import useCloseIM from '@/hooks/useCloseIM'

// store 与 WebIM 存在循环引用，必须在收到消息时延迟获取，不能在模块初始化时捕获。
const handleCmdMessage = createCmdMessageHandler({ getStore: () => store, eventBus: EventBus })

// 发送已读回执
function ack(message) {
  const dealingGroupId = computed(() => store.state.group.dealingGroupId)
  const activeTabKey = computed(() => store.state.app.tabActivekey)
  if (dealingGroupId.value === message.to && activeTabKey.value === 'Chat') {
    const bodyId = message.id // 需要发送已读回执的消息id
    const msg = new WebIM.message('read', WebIM.conn.getUniqueId())
    const { to, type } = message
    msg.set({
      id: bodyId,
      to: to,
      chatType: type
    })
    console.log('%c====发送已读回执 + reaction====', 'color: rgb(114, 46, 209)', msg.body)
    WebIM.conn.send(msg.body)
    WebIM.conn.addReaction({ messageId: bodyId, reaction: store.getters.chatId })
  }
}

// 初始化IM SDK
let WebIM = {}
WebIM = window.WebIM = websdk
WebIM.config = config
WebIM.conn = new WebIM.connection({
  appKey: WebIM.config.appkey,
  isMultiLoginSessions: WebIM.config.isMultiLoginSessions,
  https: WebIM.config.https,
  isAutoLogin: true,
  heartBeatWait: WebIM.config.heartBeatWait,
  autoReconnectNumMax: WebIM.config.autoReconnectNumMax,
  autoReconnectInterval: WebIM.config.autoReconnectInterval,
  isStropheLog: WebIM.config.isStropheLog,
  delivery: WebIM.config.delivery,
  isDebug: WebIM.config.isDebug,
  useOwnUploadFun: WebIM.config.useOwnUploadFun,
  //公有云 isHttpDNS 默认配置为true
  isHttpDNS: WebIM.config.isHttpDNS
  // 私有云设置，详细文档：http://docs-im.easemob.com/im/web/other/privatedeploy
  // isHttpDNS: false,
  // url: 'https://im-api-v2.easecdn.com/ws', // 设置为私有云的websocket server url
  // apiUrl: 'https://a1.easecdn.com', // 设置为私有云的rest server url
})

//聊天类型
const typeMap = {
  chat: 'contact',
  groupchat: 'group',
  chatroom: 'chatroom'
}
// 放到下面不生效
WebIM.conn.addEventHandler('REACTION', {
  onReactionChange: reactionMsg => {
    console.log('%c====【收到reacttion】====', 'color:orange', reactionMsg)
    store.commit('updateMessageReadReaction', reactionMsg)
  }
})
// 注册监听回调
WebIM.conn.listen({
  onOpened: function () {
    // 连接成功回调
    console.log('<==========环信登录成功========>')
    store.dispatch('onGetGroupUserList')
    EventBus.emit('onOpened', {})
  },
  // 连接关闭回调
  onClosed: function (message) {
    console.log(message, '连接关闭回调')
  },
  // 收到文本消息
  onTextMessage: function (message) {
    console.log('收到文本消息', message)
    const { from, to, type, time } = message
    const chatId = type !== 'chat' ? to : from
    store.commit('updateMsgList', {
      contentsType: 'txt',
      chatType: typeMap[message.type],
      chatId: chatId,
      msg: message.data,
      bySelf: message.from === store.getters.chatId,
      from: message.from,
      mid: message.id,
      time: time,
      newMessage: true
    })
    ack(message)
  },
  // 收到图片消息
  onPictureMessage: function (message) {
    console.log('收到图片消息', message)
    const { from, to, type, time } = message
    const chatId = type !== 'chat' ? to : from
    store.commit('updateMsgList', {
      contentsType: 'img',
      chatType: typeMap[message.type],
      chatId: chatId,
      msg: message.url,
      bySelf: message.from === store.getters.chatId,
      type: 'img',
      mid: message.id,
      from: message.from,
      time: time,
      newMessage: true
    })
    ack(message)
  },
  // 收到音频消息
  onAudioMessage: function (message) {
    console.log('收到音频消息', message)
    const { from, to, type, url, time } = message
    const changeURL = url
    // 判断环信返回的 url 与服务是不是一致
    if (location.protocol === 'http:') {
      changeURL.replace('https://', 'http://')
    } else {
      changeURL.replace('http://', 'https://')
    }
    const chatId = type !== 'chat' ? to : from
    store.commit('updateMsgList', {
      contentsType: 'audio',
      chatType: typeMap[type],
      chatId: chatId,
      msg: changeURL,
      bySelf: message.from === store.getters.chatId,
      type: 'audio',
      from: from,
      mid: message.id,
      time: time,
      newMessage: true
    })
    ack(message)
  },
  // 收到视频消息
  onVideoMessage: function (message) {
    console.log('收到视频消息', message)
    const { from, to, type, time, url } = message
    const chatId = type !== 'chat' ? to : from
    const options = {
      url,
      headers: {
        Accept: 'audio/mp4'
      },
      onFileDownloadComplete: function (response) {
        const objectURL = WebIM.utils.parseDownloadResponse.call(WebIM.conn, response)
        console.log(objectURL)
        store.commit('updateMsgList', {
          contentsType: 'video',
          chatType: typeMap[message.type],
          chatId: chatId,
          msg: objectURL,
          bySelf: message.from === store.getters.chatId,
          type: 'video',
          filename: message.filename,
          file_length: message.file_length,
          from: message.from,
          mid: message.id,
          time: time,
          newMessage: true
        })
      },
      onFileDownloadError: function () {
        console.log('视频下载失败')
      }
    }
    WebIM.utils.download.call(WebIM.conn, options)
    ack(message)
  },
  //收到自定义消息
  onCustomMessage: function (message) {
    console.log('收到自定义消息', message)
    const { from, to, type, time, customEvent, customExts } = message
    const customList = [
      '280001',
      '280002',
      '280003',
      '280004',
      '280005',
      '280006',
      '280007',
      '280008',
      '280009',
      '280010'
    ]
    const workOrderInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
    const chatToType =
      to === workOrderInfo.value.guideConsultGroupId
        ? 'guide'
        : to === workOrderInfo.value.groupId
        ? 'public'
        : 'private'
    const MembersIds = handleGroupMembers(chatToType)
    if (customList.includes(customEvent)) {
      useCustomIM(customEvent, customExts)
    } else {
      // 保存消息消息
      const chatId = type !== 'chat' ? to : from
      //屏蔽某些类型自定义消息
      if (Config.SHIELD_MSG.includes(customEvent)) return
      const newMsgs = {
        contentsType: 'custom',
        chatType: typeMap[message.type],
        chatId: chatId,
        msg: message.customExts,
        customEvent,
        bySelf: message.from === store.getters.chatId,
        from: message.from,
        mid: message.id,
        time: time,
        newMessage: true
      }
      if (newMsgs.bySelf) {
        newMsgs.msgRecipients = MembersIds
      }
      store.commit('updateMsgList', newMsgs)
      if (!Config.SYSTEM_MESSAGES.includes(customEvent) && message.from !== store.getters.chatId) {
        ack(message)
      }
    }
  },
  onPresence: function (message) {
    console.log('onPresence', message)
    switch (message.type) {
      case 'memberJoinPublicGroupSuccess': // 成员加入聊天室成功回调
        EventBus.emit('memberJoinPublicGroupSuccess', message.gid)
        break
      case 'removedFromGroup': //移除
        break
      default:
        break
    }
  },
  // 处理“广播”或“发布-订阅”消息，如联系人订阅请求、处理群组、聊天室被踢解散等消息
  onRoster: function (message) {
    console.log('onRoster', message)
  },
  // 处理好友申请
  onInviteMessage: function (message) {
    console.log('onInviteMessage', message)
  },
  // 处理群组邀请
  onOnline: function () {
    console.log('onOnline 网络已连接')
  },
  // 本机网络连接成功
  onOffline: function () {
    console.log('onOffline 网络已断开')
  },
  // 本机网络掉线
  onError: function (message) {
    console.log('onError', message)
    EventBus.emit('onError', message)
    if (message.type == 0) {
      return Message.error('请输入账号密码')
    } else if (message.type == 28) {
      return console.log('未登陆')
    } else if (
      _.get(message, 'data.type') === 17 &&
      JSON.parse(message.data.data).error_description == 'user not found'
    ) {
      return Message.error('环信账号未注册! ')
    } else if (
      _.get(message, 'data.type') === 17 &&
      JSON.parse(message.data.data).error_description == 'invalid password'
    ) {
      return Message.error('密码无效! ')
    } else if (
      _.get(message, 'data.type') === 17 &&
      JSON.parse(message.data.data).error_description == 'user not activated'
    ) {
      return Message.error('用户已被封禁! ')
    } else if (message.type == '504') {
      return Message.error('消息撤回失败')
    }
  },
  // 撤回回调
  onRecallMessage: message => {
    console.log('撤回消息', message)
    message.status = 'recall'
    message.msgStatus = -1
    store.commit('updateMessageStatus', message)
    EventBus.emit('receivedMessage', message)
  },
  // 收到消息送达服务器回执
  onReceivedMessage: function (message) {
    store.commit('updateMessageMid', message)
    message.status = 'sent'
    store.commit('updateMessageStatus', message)
  },
  onDeliveredMessage: function (message) {
    console.log(
      '%c====【onDeliveredMessage收到消息送达客户端回执回执】====',
      'color:orange',
      message
    )
    // store.commit('updateMessageStatus', message)
  },
  // 收到消息送达客户端回执
  onReadMessage: function (message) {
    console.log('%c====【onReadMessage收到消息送达客户端回执】====', 'color:#F41112', message)
    message.status = 'read'
    store.commit('updateMessageReadAck', message)
  },
  // 当前用户收到透传消息。
  onCmdMessage: function (message) {
    console.log('%c====【onCmdMessage收到透传消息】====', 'color:red', message)
    handleCmdMessage(message)
  }
})

export default WebIM
